export default function dynamicDropdown(options = {}) {
  // Configuration options with default values
  const {
    parentIndicator = "[-]",
    childIndicator = "[--]",
    dropdownContainerClass = "has_dropdown",
    submenuClass = "v-dropdown",
    caretWrapperClass = "v-caret-wrapper",
    caretIconClass = "caret-icon",
    isVisibleClass = "is_visible",
    menuLinkClass = "v-head-menu",
    caretIconContent = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" fill="currentColor" class="caret-icon">
                          <path d="m325.61 79.393c-5.857-5.857-15.355-5.858-21.213 1e-3l-139.39 139.39-139.4-139.39c-5.857-5.857-15.355-5.858-21.213 1e-3 -5.858 5.858-5.858 15.355 0 21.213l150 150c2.813 2.813 6.628 4.393 10.606 4.393s7.794-1.581 10.606-4.394l150-150c5.859-5.857 5.859-15.355 1e-3 -21.213z"/>
                        </svg>`
  } = options;

  // Find parent elements
  const parentElements = document.querySelectorAll("ul li");

  // Iterate through parent elements
  parentElements.forEach(function(parentElement) {
    const parentLink = parentElement.querySelector("a");
    if (parentLink && parentLink.textContent.includes(parentIndicator)) {
      // Create submenu element
      const submenu = document.createElement("ul");
      submenu.classList.add(submenuClass);

      // Collect child elements
      const childElements = [];
      let siblingElement = parentElement.nextElementSibling;
      while (siblingElement && !siblingElement.querySelector("a").textContent.includes(parentIndicator)) {
        if (siblingElement.querySelector("a").textContent.includes(childIndicator)) {
          childElements.push(siblingElement);
        }
        siblingElement = siblingElement.nextElementSibling;
      }

      // Move child elements to the submenu
      childElements.forEach(function(childElement) {
        submenu.appendChild(childElement.cloneNode(true));
        childElement.remove();
      });

      // Add dropdown container class to the parent element
      parentElement.classList.add(dropdownContainerClass);

      // Create caret wrapper element
      const caretWrapper = document.createElement("span");
      caretWrapper.classList.add(caretWrapperClass);

      // Create caret icon element
      const caretIcon = document.createElement("div");
      caretIcon.innerHTML = caretIconContent.trim();
      caretIcon.firstChild.classList.add(caretIconClass);

      // Append caret icon to the caret wrapper
      caretWrapper.appendChild(caretIcon.firstChild);
      parentLink.appendChild(caretWrapper);

      // Handle click events to show/hide the submenu
      window.addEventListener("click", function(event) {
        if (!parentElement.contains(event.target)) {
          parentElement.classList.remove(isVisibleClass);
        }
      });

      caretWrapper.addEventListener("click", function(event) {
        event.preventDefault();

        const isDropdownOpen = parentElement.classList.contains(isVisibleClass);
        const visibleDropdown = document.querySelector("." + isVisibleClass);

        if (visibleDropdown) {
          visibleDropdown.classList.remove(isVisibleClass);
        }

        if (!isDropdownOpen) {
          parentElement.classList.add(isVisibleClass);
        }

        event.stopPropagation();
      });

      // Append the submenu to the parent element
      parentElement.appendChild(submenu);
    }
  });

  // Remove indicator text from menu links
  removeText(parentIndicator, caretWrapperClass, menuLinkClass);
  removeText(childIndicator, caretWrapperClass, menuLinkClass);
}

// Function to remove indicator text from menu links
function removeText(text, caretWrapperClass, menuLinkClass) {
  const elements = document.querySelectorAll(`nav .${menuLinkClass} a`);

  elements.forEach(function(element) {
    const caretWrapper = element.querySelector("." + caretWrapperClass);
    if (caretWrapper) {
      caretWrapper.remove();
    }

    const originalText = element.textContent;
    element.textContent = originalText.replace(text, "").trim();

    if (caretWrapper) {
      element.appendChild(caretWrapper);
    }
  });
}